<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CustomLoader from "@/components/widgets/custom-loader";
import { mapActions, mapGetters } from "vuex";
import Vue from "vue";
import excel from "vue-excel-export";
Vue.use(excel);
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Students Archive",
    meta: [
      {
        name: "Students who left the school",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomLoader,
  },
  data() {
    return {
      title: "Students Archive",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Students Archive",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pageOptions: [100, 200],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          sortable: false,
          key: "actions",
          label: "Action",
        },
        {
          key: "student",
          label: "Student's Name",
          sortable: true,
        },
        {
          key: "gender",
          label: "Gender",
          sortable: true,
        },
        {
          key: "classx",
          label: "Level",
          sortable: true,
        },
        {
          key: "course.name",
          label: "Course",
          sortable: true,
        },
        {
          key: "address",
          label: "Home Residence",
          sortable: true,
        },
        {
          key: "contact",
          label: "Contact(s)",
          sortable: true,
        },
      ],
      filterData: {
        studentName: "",
        course: "",
        year: "",
        class: ""
      },
    };
  },
  computed: {
    ...mapGetters("students", [
      "SaveStatus",
      "FetchingStudents",
      "getFetchArchiveStudents",
      "getSearchedStudents",
      "getSearchingStudents"
    ]),
    ...mapGetters("classes", [
      "AllCourses",
      "CustomClasses",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("marks", ["getYears"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.getFetchArchiveStudents ? this.getFetchArchiveStudents.length : 1;
    },
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
        // this.closeModal(this.modal);
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.getFetchArchiveStudents ? this.getFetchArchiveStudents.length : 1;
  },
  methods: {
    ...mapActions({
      FetchArchiveStudents: "students/fetchArchiveStudents",
      SearchStudent: "students/searchStudent",
      FetchYears: "marks/fetchYear",
      FetchCourses: "classes/fetchCourses",
      FetchCustomClasses: "classes/fetchCustomClasses",
    }),

    //Handling student's photo
    handleFileUpload(event) {
      this.data.photo = event.target.files[0];
    },

    //student's upload
    handleFileUploadStudent(event) {
      this.upload.studentFile = event.target.files[0];
    },

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.getFetchArchiveStudents.length;
      this.currentPage = 1;
    },
    submitFilter() {
      // this.SearchStudent({name: this.filterData.studentName});
      this.SearchStudent(this.filterData);
    },
    fetchLevelinCourse() {
      const courseSelected = {
        course: this.filterData.course,
      };
      this.FetchCustomClasses(courseSelected);
    },
  },
  created() {
    this.FetchArchiveStudents();
    this.FetchYears();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_students')
        )
      "
    >
    <div class="col-12">
        <b-card no-body class="mb-1 shadow-none">
            <b-card-body>
              <form @submit.prevent="submitFilter()">
                <div class="row">
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Year <small class="text-danger">*</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        required
                        v-model="filterData.year"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Year</option>
                        <option
                          v-for="(schyear, index) in getYears"
                          :value="schyear.year"
                          :key="index"
                        >
                          {{ schyear.year }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Course <small class="text-danger">*</small></label
                      >
                      <select
                        required
                        v-model="filterData.course"
                        class="form-control form-control-sm"
                        @change="fetchLevelinCourse()"
                      >
                        <option v-if="SaveStatus" selected value="" disabled>
                          Fetching Courses...
                        </option>
                        <option v-else selected value="" disabled>
                          Select Course
                        </option>
                        <option
                          v-for="(course, index) in AllCourses"
                          :key="index"
                          :value="course.id"
                        >
                          {{ course.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="form-group">
                      <label for=""
                        >Level <small class="text-danger">*</small></label
                      >
                      <select
                        class="form-control form-control-sm"
                        required
                        v-model="filterData.class"
                        name=""
                        id=""
                      >
                        <option value="" selected disabled>Select Level</option>
                        <option
                          v-for="(classes, index) in CustomClasses"
                          :key="index"
                          :value="classes.id"
                        >
                          {{ classes.short }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3 mt-3">
                    <button
                      type="submit"
                      size="sm"
                      disabled
                      class="btn btn-sm btn-outline-primary mt-2"
                      v-if="FetchingStudents"
                    >
                      <b-spinner
                        variant="primary"
                        small
                        label="Fetching Data..."
                      ></b-spinner>
                      Fetching Data...
                    </button>
                    <button
                      v-else
                      type="submit"
                      size="sm"
                      class="btn btn-sm btn-outline-primary mt-2"
                    >
                      <i class="fa fa-check"></i>
                      Submit Filers
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
        </b-card>
      </div>
      <!-- <div class="col-12">
        <b-card no-body class="mb-1 shadow-none">
          <b-card-body>
            <form @submit.prevent="submitFilter()">
              <div class="row">
                <div class="form-group col-md-4">
                  <div class="form-group">
                    <label for=""
                      >Search Archieved Student</label
                    >
                    <input
                      class="form-control form-control"
                      placeholder="Enter Student's Name..."
                      required
                      v-model="filterData.studentName"
                      name=""
                      id=""
                    />
                  </div>
                </div>
                <div class="col-md-3 mt-3">
                  <button
                    type="submit"
                    size="sm"
                    disabled
                    class="btn btn-outline-primary mt-2"
                    v-if="FetchingStudents"
                  >
                    <b-spinner
                      variant="primary"
                      small
                      label="Fetching Data..."
                    ></b-spinner>
                    Fetching Data...
                  </button>
                  <button
                    v-else
                    type="submit"
                    size="sm"
                    class="btn btn-outline-primary mt-2"
                  >
                    <i class="fa fa-check"></i>
                    Submit Filers
                  </button>
                </div>
              </div>
            </form>
            <div class="col-12 mt-3 mb-2" v-if="getSearchedStudents != ''">
            <span class="text-muted">
              Searched Students: 
              <button onClick="window.location.reload();" class="btn btn-sm btn-danger">
                Clear Filter <i class="fa fa-times-circle" aria-hidden="true"></i>
              </button>
            </span>
            <ul v-if="getSearchedStudents.length > 0">
              <li class="mt-1" v-for="(std, stdIndex) in getSearchedStudents" :key="stdIndex">
                <router-link :to="'/students/details/' + std.id" role="link">
                  {{std.name}} | Course: {{ std.course.name }} | Class: {{ std.classx.name }}
                </router-link>
              </li>
            </ul>
            <ul v-else>
              <li class="mt-1"> No students found</li>
            </ul>
          </div>
          <CustomLoader v-if="getSearchingStudents"></CustomLoader>
          </b-card-body>
        </b-card>
      </div> -->
      <CustomLoader v-if="FetchingStudents"></CustomLoader>
      <div class="col-12" v-else>
        <div class="card" v-if="getFetchArchiveStudents">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-12">
                <h3 class="card-title text-primary">Archived students List</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                class="datatables student-list"
                :items="getFetchArchiveStudents"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(student)="data">
                  {{ data.item.student.name }}
                </template>
                <template #cell(actions)="data">
                  <b-dropdown size="sm">
                    <template v-slot:button-content>
                      Action
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item>
                      <router-link
                        class="text-success"
                        :to="'/students/details/' + data.item.sid"
                      >
                        <i class="bx bx-aperture"></i> Student Details
                      </router-link>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <template #cell(residence)="data">
                  {{ data.item.residence == "1" ? "Day" : "Boarding" }}
                </template>
                <template #cell(classx)="data">
                  {{ data.item.classx.short }}
                </template>
                <template #cell(gender)="data">
                  {{ data.item.student.gender }}
                </template>
                <template #cell(streamx)="data">
                  {{ data.item.streamx.name }}
                </template>
                <template #cell(address)="data">
                  {{
                    data.item.student.address
                      ? data.item.student.address
                      : data.item.student.resident
                  }}
                </template>
                <template #cell(contact)="data">
                  {{
                    data.item.student.contact
                      ? data.item.student.contact
                      : data.item.student.gcontacts
                  }}
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-body">
            <div class="alert alert-primary text-center" role="alert">
              <span>No Students Found</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
